import React, { useEffect, useState } from 'react';
import { ErrorBar } from '@agria/theme/src/components/errorBar/ErrorBar';
import { useIsAlive } from '@agria/paws/src/hooks/useIsAlive';
import { SiteMaintenance } from '@agria/theme/src/components/icon';
import { useNetworkStatus } from '@agria/theme/src/context/NetworkContext';

export const ErrorBarMaintenance: React.FC = () => {
  const { isOnline } = useNetworkStatus();
  const { isError, isLoading, status } = useIsAlive({
    // Reattempt connection every 20 seconds
    refetchInterval: 20000,
    // Retry a failed attempt after 2s, then again after 4s
    retryDelay: (attemptIndex) => 2000 * 2 ** attemptIndex,
    retry: 2,
  });
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    // Set error state to true if we're online and an error occurs
    if (isOnline && isError) {
      setShowError(true);
    }

    // Only reset the error state when we successfully connect
    if (status === 'success') {
      setShowError(false);
    }
  }, [isOnline, isError, status]);

  // Initial loading - don't show error during first load
  const isInitialLoading = isLoading && !showError;

  // Only show maintenance error when we're online and have detected an API error
  // But don't hide it during retry attempts
  const showMaintenanceError = isOnline && showError && !isInitialLoading;

  return (
    <ErrorBar
      icon={
        <SiteMaintenance
          size="small"
          color="systemError100"
          aria-hidden="true"
        />
      }
      message={
        <>
          <strong>We are currently undertaking site maintenance.</strong> Please
          check back later when we're back up and running again.
        </>
      }
      display={showMaintenanceError}
    />
  );
};
